import { valueOf } from "@/types/common";

/**
 * Master data types shown on the master-data management screen.
 * Add an entry here as each master type is introduced.
 */
export const MASTER_DATA_TYPE = {
  PRODUCT: "product",
} as const;

export type TMasterDataType = valueOf<typeof MASTER_DATA_TYPE>;

/**
 * Japanese display title per master data type. Add a title alongside every
 * entry added to `MASTER_DATA_TYPE`.
 */
export const MASTER_DATA_TYPE_TITLE: Record<string, string> = {
  [MASTER_DATA_TYPE.PRODUCT]: "プロダクト",
};
